import teachingList from "@/components/teaching/curriculum/CurriculumList.vue";

export default {
    path: 'teaching',
    name: 'teachingForm',
    component(){
        return import('@/components/teaching/TeachingForm.vue');
    },
    children: [
        {
            path: '',
            name: 'teachingList',
            component() {
                return import('@/components/teaching/curriculum/CurriculumList.vue');
            }
        },
        {
            path: 'new',
            name: 'newMethodList',
            component() {
                return import('@/components/teaching/newMethod/newMethodList.vue');
            }
        },
        {
            path: 'master',
            name: 'masterList',
            component() {
                return import('@/components/teaching/master/MasterList.vue');
            }
        },
        {
            path: 'student',
            name: 'studentList',
            component() {
                return import('@/components/teaching/studentAdvising/StudentAdvisingList.vue');
            }
        },
        {
            path: 'student/:id',
            name: 'studentDetail',
            component() {
                return import('@/components/teaching/studentAdvising/StudentAdvisingDetail.vue');
            }
        },

    ],
}